import useStrings from "../../localization/useStrings"
import images from "../../utils/images"
import SubfeaturesPopup from "../SubfeaturesPopup/SubfeaturesPopup"
import { useUltimateAlerts } from "../../context/ultimateAlertsContext"

const UltimateSubfeaturesPopups = () => {
  const allStrings = useStrings()
  const strings = allStrings.features
  const icons = images.ultimate.features
  const { state } = useUltimateAlerts()

  const showDuplicateDetection =
    state.featureAlertSource === "bubbleFeatureList"

  const duplicateDetectionFeature = {
    title: strings.duplicateDetection,
    description:
      allStrings.premiumToUltimateBlackFriday.duplicateDetection.description,
    imageClass: icons.duplicateDetectionIcon.class,
  }

  return (
    <>
      <SubfeaturesPopup
        title={strings.organizationPlus}
        type="organization+"
        headerImageClass={icons.organizationModalIcon.class}
        features={[
          { ...strings.subalbums, imageClass: icons.subalbumsIcon.class },
          {
            ...strings.filteringAndSearching,
            imageClass: icons.searchFilterIcon.class,
          },
          ...(showDuplicateDetection ? [duplicateDetectionFeature] : []),
        ]}
      />
      <SubfeaturesPopup
        title={strings.securityPlus}
        type="security+"
        headerImageClass={icons.securityModalIcon.class}
        features={[
          {
            ...strings.alphanumericPasscode,
            imageClass: icons.alphanumericIcon.class,
          },
          { ...strings.dualLock, imageClass: icons.dualLockIcon.class },
          {
            ...strings.locationBasedLock,
            imageClass: icons.locationLockIcon.class,
            comingSoon: true,
          },
        ]}
      />
    </>
  )
}

export default UltimateSubfeaturesPopups
